import $ from 'jquery'
import store_config from "@/store/mods/parametres/config"
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';

export default {
    name: 'manage-resultat-examen',
    components: {
        VueEditor
    },
    props: {
        type_examen_id: Number,
        result_to_fill: {
            type: Object,
            default: () => ({}) // Default value is an empty object
        },
        active_role: Object,
        user_info: Object,
        rst_toggler: Number
    },
    data() {
        return {
            customToolbar: vueEditorToolbar,
            one_is_empty: false,
			both_is_empty: false,
            is_error: false,
            files: [],
            save_loading: false,

            mdl_loading: true,
            mdl_empty: false,
            mdl_error: false,
            
            liste_modeles: [],
            selected_modele: '',
            compte_rendu: '',
        }
    },

    watch: {
        rst_toggler() {
            this.clearAll()
            this.files = []
            this.selected_modele = ''

            this.fetchModeleExamen()
        },

        selected_modele() {
            this.autoFillCompteRendu()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        fetchModeleExamen() {
            this.mdl_loading = true

            const data = {
                type_examen_id: this.type_examen_id
            }
            store_config.getListeModeleExamens(data).then((response) => {
                this.liste_modeles = response
                if (response.length == 0) {
                    this.mdl_empty = true
                } else {
                    this.mdl_empty = false
                }
                this.mdl_loading = false
            }).catch(() => {
                this.mdl_loading = false
                this.mdl_error = true
            })
        },

        autoFillCompteRendu() {
            let content = this.selected_modele.model_field.default_value
            content = content.replace("[NOM_MEDECIN]", this.user_info.nom)
            content = content.replace("[NOM_PATIENT]", this.result_to_fill.patient)
            content = content.replace("[DATE_NAISSANCE_PATIENT]", this.result_to_fill.date_naissance)
            content = content.replace("[AGE_PATIENT]", this.result_to_fill.age)
            content = content.replace("[VILLE]", this.ville_le)
            content = content.replace("[DATE]", this.result_to_fill.date_demande_examen)
            content = content.replace("[NOM_CLINIQUE]", this.nom_clinique)

            this.result_to_fill.examen_commentaire = content
        },

        handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.result_to_fill.result_examen = this.files[0];
            this.clearAll()
		},

        clearAll() {
            this.both_is_empty = false 
			this.one_is_empty = false
			this.is_error = false
			$('.err-msg').fadeOut(500)
			$('.err-fsize').fadeOut(500)
			$('.err-extension').fadeOut(500)
		},

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        saveResultat() {
			let comment_is_empty = false,
				file_is_empty = false

			if (this.result_to_fill.examen_commentaire == '' && this.active_role.nom == 'ROLE_RADIOLOGUE') {
				comment_is_empty = true
			}

			if (this.result_to_fill.result_examen == null) {
				file_is_empty = true
			}

			let confirm = document.getElementById('cfrm-exm-result');


			if (comment_is_empty && file_is_empty) {
				this.both_is_empty = true

				return;
			} else if (
				( (!comment_is_empty && file_is_empty) || (comment_is_empty && !file_is_empty) ) && 
				(!confirm || confirm.checked == false)
			) {
				this.one_is_empty = true
				if (confirm && confirm.checked == false) {
					$('.err-msg').fadeIn(500)
				}

				return;
			} 

            let max_file_size = 5120
            
            if (!file_is_empty) {
                if (!this.fileValidation(max_file_size, 'files')) {
                    return;
                }
            }
			
			

            const is_technicien = (this.active_role.nom == 'ROLE_TECHNICIEN_IMAGERIE')?1:0
            let data = {
                demande_id: this.result_to_fill.demande_id,
                commentaire: this.result_to_fill.examen_commentaire,
                result_examen: this.result_to_fill.result_examen,
                user_info: JSON.stringify(this.user_info),
                user_id: this.user_info.id,
                is_technicien: is_technicien,
                titre_interpretation: (this.selected_modele?.model_field?.champ)?this.selected_modele.model_field.champ:'',
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.save_loading = true
            this.$store.dispatch('saveResultatExamen', form_data).then((response) => {
                if (response > 0) {
                    this.$emit("emitRefreshList")
                    
                    this.result_to_fill = {
                        demande_id: 0,
                        examen_nom: '',
                        result_examen: null,
                        examen_commentaire: ''
                    }
                    this.files = []
					this.clearAll()

                    this.$refs.rslt_exam.click()
                    this.successToast("Résultat enregistré avec succès")
					
                    
                } else {
                    this.errorToast('Une erreur est survenue! Merci de réessayer.')
                }
				this.save_loading = false
            }).catch(() => {
				this.is_error = true
                this.save_loading = false
            })
        },
    }
}